import styled from 'styled-components/macro'
import { theme } from 'styles/theme'

export const MapContainer = styled.div`
  position: relative;
  width: 100%;
  /*aspect-ratio: 16/9;*/
  .map-container {
    aspect-ratio: 16/11;
  }
  .ol-zoom {
    position: absolute;
    bottom: 9px;
    right: 6px;
    border-radius: 4px;
    button {
      border: 1px solid rgba(0, 0, 0, 0.2);
      display: block;
      width: 30px;
      height: 30px;
      line-height: 30px;
      padding: 0px;
      border-radius: 4px;
      appearance: none;
      background: rgba(255, 255, 255, 0.85);
      transition: background 0.3s;
      text-align: center;
      cursor: pointer;
      font-size: 17px;
    }
    .ol-zoom-in {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
    .ol-zoom-out {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
  }
  .ol-rotate {
    display: none;
  }
`
export const Popup = styled.div<{ $popupActive: boolean }>`
  display: ${(props) => (props.$popupActive ? 'block' : 'none')};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: calc(var(--spacing-sm) / 2) var(--spacing-sm)
    calc(var(--spacing-sm) / 2) calc(var(--spacing-sm) / 2);
  background: white;

  button {
    position: absolute;
    box-sizing: border-box;
    right: 0px;
    top: 0px;
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    border-radius: 0 3px 0 0;
    cursor: pointer;
    color: #666;
    background-color: transparent;
    font-size: 24px;
    line-height: 30px;
    font-family: Tahoma, Verdana, sans-serif;
    &:focus {
      color: #666;
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
`
export const MapHeader = styled.div`
  margin: 0px;
  padding: 0px;
  border: none;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: start;
  justify-content: flex-start;
  gap: 16.2px;
`
export const MapTitle = styled.h2`
  margin: 0;
  font-size: 22px;
  //color: rgb(56, 56, 56);
  color: ${theme.colors.text};
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`

export const MapDescription = styled.p`
  font-size: 16px;
  //color: rgb(56, 56, 56);
  color: ${theme.colors.text};
  font-weight: 400;
  margin: 0;
`
export const MapSource = styled.div`
  color: rgb(19, 47, 70);
  font-size: 11px;
  font-weight: 400;
  padding-top: var(--spacing-sm);
  a {
    text-decoration: none;
    color: rgb(0, 136, 204);
  }
`
